(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jadash-homepage"] && !Shopify.designMode) return;
  try {
    
  const jadashReveal = document.querySelectorAll('[data-jadash-reveal]');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    jadashReveal.forEach((element) => observer.observe(element));
  } else {
    jadashReveal.forEach((element) => element.classList.add('is-visible'));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('[data-product-variant]').forEach((select) => {
    select.addEventListener('change', () => {
      const selected = select.options[select.selectedIndex];
      const price = select.closest('.jadash-main-product__info')?.querySelector('[data-product-price]');
      if (price && selected.dataset.price) price.textContent = selected.dataset.price;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-header"]) return;
  try {
    
document.querySelectorAll('[data-jadash-language]').forEach((select)=>{select.addEventListener('change',()=>select.form.submit())});document.querySelectorAll('[data-jadash-mobile-menu]').forEach((menu)=>{menu.addEventListener('toggle',()=>document.body.classList.toggle('menu-open',menu.open));menu.querySelector('[data-jadash-menu-close]')?.addEventListener('click',()=>{menu.removeAttribute('open');document.body.classList.remove('menu-open')});menu.querySelectorAll('a').forEach((link)=>{link.addEventListener('click',()=>{menu.removeAttribute('open');document.body.classList.remove('menu-open')})})});

  } catch(e) { console.error(e); }
})();
})();
